import { Spinner } from "@swivl-mono/ui";
import * as React from "react";

import { HorizontalBarGraph, HorizontalBarGraphData } from "../HorizontalBarGraph/HorizontalBarGraph";
import { PieChart, PieChartRow } from "../PieChart/PieChart";
import "./BarAndPieChart.scss";

interface Props {
  data?: BarAndPieChartData[];
  showTotals?: boolean;
  height: number;
  width: number;
}
interface State {
  percentage: string;
  label: string;
  showInfo: boolean;
}
export interface BarAndPieChartDataRow {
  value: number;
  color: string;
}
export interface BarAndPieChartData {
  title: string;
  value: number;
}
export class BarAndPieChart extends React.Component<Props, State> {
  colors = ["#ffa904", "#ff940e", "#ff7d1b", "#ff6528", "#ff4b34", "#ECECEC", "#999999", "#666666", "#333333", "#000000"];
  constructor(props: Props) {
    super(props);
    this.state = { showInfo: true, label: "Sup", percentage: "25%" };
  }

  chartData(dataUnsorted: BarAndPieChartData[]): { barData: HorizontalBarGraphData[]; pieData: PieChartRow[] } {
    const data = dataUnsorted.sort((a, b) => {
      return b.value - a.value;
    });

    let cdata: any = { barData: [], pieData: [] };
    let other = 0;
    for (let i = 0; i < data.length; i++) {
      const datum = data[i];

      if (i < 5) {
        cdata.barData.push({ title: datum.title, rows: [{ value: datum.value, color: this.colors[i] }], total: datum.value });
        cdata.pieData.push({ label: datum.title, value: datum.value, color: this.colors[i] });
      } else {
        other += datum.value;
      }
    }
    if (other) {
      cdata.pieData.push({ label: "Other", value: other, color: this.colors[5] });
    }

    return cdata;
  }

  render() {
    const { data, showTotals, height, width } = this.props;
    const { percentage, label, showInfo } = this.state;

    if (!data) {
      return (
        <div className={"BarAndPieChart"}>
          <div className={"loadingView"}>
            <Spinner />
          </div>
        </div>
      );
    }
    const chartData = this.chartData(data);

    return (
      <div className={"BarAndPieChart"}>
        <div className={"barChart"} style={{ height: height + "px", width: width - height + "px" }}>
          <HorizontalBarGraph data={chartData.barData} showTotals={showTotals} />
        </div>
        <div className="pieChart" style={{ height: height + "px", width: height + "px" }}>
          <PieChart data={chartData.pieData} height={height - 40} />
        </div>
      </div>
    );
  }
}
